export type StatusTone = "good" | "warn" | "bad" | "neutral";

const BAD_RX  = /^(not[\s_-]+authorized|out[\s_-]+of[\s_-]+service|revoked|inactive|suspended|expired|rejected|failed|denied|blocked|cancelled|canceled)\b/i;
const WARN_RX = /^(pending|review|expiring|conditional|provisional|warning|in_review|under_review)\b/i;
const GOOD_RX = /^(authorized|active|verified|valid|approved|satisfactory|current|clear|on[\s_-]?file|enabled|ok|pass(ed)?)\b/i;
const NEUTRAL_RX = /^(none|unknown|n\/a|null|—|-)\s*$/i;

export function statusTone(status: string | null | undefined): StatusTone {
  if (!status) return "neutral";
  const s = String(status).trim();
  if (!s || NEUTRAL_RX.test(s)) return "neutral";
  if (BAD_RX.test(s))  return "bad";
  if (WARN_RX.test(s)) return "warn";
  if (GOOD_RX.test(s)) return "good";
  return "warn";
}

export const BADGE_TONE_CLASS: Record<StatusTone, string> = {
  good:    "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  warn:    "bg-amber-500/15 text-amber-400 border-amber-500/30",
  bad:     "bg-red-500/15 text-red-400 border-red-500/30",
  neutral: "bg-slate-500/15 text-slate-400 border-slate-500/30",
};

export const BADGE_OUTLINE_TONE_CLASS: Record<StatusTone, string> = {
  good:    "text-emerald-400 border-emerald-500/30",
  warn:    "text-amber-400 border-amber-500/30",
  bad:     "text-red-400 border-red-500/30",
  neutral: "text-slate-400 border-slate-500/30",
};
